import { Typography } from '@mui/material';
import { SubBar } from '@components/SubBar';
import { useNavigate } from 'react-router-dom';
import { DesignTable } from '@components/tables/DesignTable';
import { useMemo, useState, useEffect } from 'react';
import { DesignEditDialog } from '@components/dialogs/DesignEditDialog';
import { OrangeButton } from '@components/buttons/OrangeButton';
import { BackButton } from '@components/buttons/BackButton';
import { designAPI } from '@api/designs';
import { useSelector } from 'react-redux';
import { useLoadDesignData } from '@hooks/useLoadDesignData';
import parse from 'query-string';
import { AppRoutes } from '@consts/routes';
import { keyBy } from '@utils/data';
import { LoadingScreen } from '@components/LoadingScreen';
import { BasePage } from './bases/BasePage';

import type { RootState } from '@features/redux/store';
import type { Model } from '@features/redux/slices/designSlice';

export const Design = () => {
    const navigate = useNavigate();

    const { model: modelId, manufacturer: manufacturerId } = (parse.parse(location.search) || {}) as {
        model?: string;
        manufacturer?: string;
    };

    useEffect(() => {
        if (!modelId || !manufacturerId) {
            navigate(AppRoutes.Models);
        }
    }, [modelId, manufacturerId]);

    const { IdToken } = useSelector((state: RootState) => state.auth);

    const { getModel } = designAPI(IdToken as string);

    const { coverages } = useLoadDesignData();

    const [model, setModel] = useState<Model>();

    const [selectedCoverage, setSelectedCoverage] = useState<string>();

    const [editOpen, setEditOpen] = useState(false);

    const loadModel = async () => {
        if (modelId && manufacturerId) {
            const device = await getModel(modelId);
            setModel(device);
        }
    };

    const openEditDialog = (selectedCoverageId?: string) => {
        setEditOpen(true);
        setSelectedCoverage(selectedCoverageId);
    };

    const closeDialog = (updatedData: boolean) => {
        setEditOpen(false);
        setSelectedCoverage(undefined);

        if (updatedData) {
            loadModel();
        }
    };

    useEffect(() => {
        loadModel();
    }, []);

    const coverageMap = useMemo(() => keyBy(coverages, 'coverageId'), [coverages]);

    return model ? (
        <BasePage>
            <div style={{ marginTop: '180px' }}>
                <SubBar>
                    <div
                        style={{
                            display: 'flex',
                            flex: 1,
                            flexDirection: 'row',
                            justifyContent: 'flex-start',
                        }}>
                        <BackButton text={'Models'} onClick={() => navigate(AppRoutes.Models)} />

                        <Typography
                            style={{
                                color: 'white',
                                fontSize: '15px',
                                marginBottom: '2.5px',
                                marginLeft: '5px',
                                padding: '5px',
                            }}>
                            <b>{model ? model.model : ''}</b>
                        </Typography>

                        <OrangeButton onClick={() => openEditDialog()}>+ Design</OrangeButton>
                    </div>
                </SubBar>

                <DesignTable
                    selectDesign={openEditDialog}
                    loadModel={loadModel}
                    coverageMap={coverageMap}
                    model={model}
                />

                {editOpen && (
                    <DesignEditDialog
                        model={model}
                        coverageMap={coverageMap}
                        selectedCoverageId={selectedCoverage}
                        cancel={closeDialog}
                    />
                )}
            </div>
        </BasePage>
    ) : (
        <LoadingScreen active={true} />
    );
};
